import { jsx as i } from "../../_virtual/jsx-runtime.mjs";
import * as a from "react";
import o from "./ReoInput.mjs";
import { measureInputSuffix as f, measureInput as r, measureContainer as l } from "./css/ReoMeasureInput.mjs";
import t from "../../depend/classnames/index.mjs";
import { useTheme as N } from "../../hook/useTheme.mjs";
import { EThemeTemplate as c } from "../../common/type.mjs";
const C = (e) => {
  const m = N({ theme: e == null ? void 0 : e.theme, template: c.MEASURE_INPUT }), s = a.useMemo(() => t(
    m,
    f,
    e.suffixClassName
  ), [e.suffixClassName, m]), u = a.useMemo(() => t(
    m,
    r,
    e.inputClassName
  ), [e.inputClassName, m]), n = a.useMemo(() => t(
    m,
    l,
    e.containerClassName
  ), [e.containerClassName, m]);
  return /* @__PURE__ */ i(
    o,
    {
      ...e,
      suffixClassName: s,
      inputClassName: u,
      containerClassName: n
    }
  );
};
C.displayName = "MeasureInput";
export {
  C as default
};
//# sourceMappingURL=MeasureInput.mjs.map
